import apiClient, { prefetchApiCsrfToken } from "../common";

const JSON_API_MEDIA = "application/vnd.api+json";

export type ProcurementExportResult = {
  id: string;
  export_status: string;
  message: string;
};

function parseExportResponse(payload: unknown): ProcurementExportResult {
  const row =
    (payload as { data?: Record<string, unknown> })?.data ??
    (payload as Record<string, unknown>);
  const attrs =
    (row?.attributes as Record<string, unknown> | undefined) ?? {};
  return {
    id: String(row?.id ?? ""),
    export_status: String(
      attrs.export_status ?? attrs["export-status"] ?? "",
    ),
    message: String(attrs.message ?? ""),
  };
}

function buildProcurementExportBody(supplyDocumentId: string) {
  return {
    data: {
      type: "procurement-exports",
      id: supplyDocumentId,
      attributes: {},
    },
  };
}

/** POST /api/v1/supply-documents/{id}/procurement-export/ */
export async function apiProcurementExportSupplyDocument(
  supplyDocumentId: string,
): Promise<ProcurementExportResult> {
  await prefetchApiCsrfToken();
  const res = await apiClient.post(
    `supply-documents/${supplyDocumentId}/procurement-export/`,
    buildProcurementExportBody(supplyDocumentId),
    {
      headers: {
        Accept: JSON_API_MEDIA,
        "Content-Type": JSON_API_MEDIA,
      },
    },
  );
  return parseExportResponse(res.data);
}
